import { useCallback } from 'react';
import type { DataSchema } from '../types';
import type { UseFormReturn } from 'react-hook-form';
import type { TableFormData } from '../components/common/Table/Table.tsx';
import type { FormStateSnapshot } from '../contexts/FormRegistryProvider.tsx';

export function useFormSnapshot<P extends DataSchema>(form: UseFormReturn<TableFormData>, dataSchema: P) {
  const buildSnapshot = useCallback(
    (): FormStateSnapshot<P> => ({
      values: form.getValues(),
      dirtyFields: form.formState.dirtyFields,
      isDirty: form.formState.isDirty,
      errors: form.formState.errors,
      touchedFields: form.formState.touchedFields,
      isValid: form.formState.isValid,
      dataSchema,
    }),
    [form, dataSchema]
  );

  return { buildSnapshot };
}
